import DataTableBase from "../../../../ui/data_tables/DataTableBase";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartLine} from "@fortawesome/free-solid-svg-icons";
import React, {Fragment, useState} from "react";
import {NotScoredVideoItem, ScoredVideoItem} from "../../../../ui/video_player/VideoItem";
import * as PropTypes from "prop-types";
import VideosPerMatchModal from "../modals/VideosPerMatchModal";
import PerformanceInMinutesPlayedModal from "../modals/PerformanceInMinutesPlayedModal";
import AssistsByPlayerModal from "../modals/AssistsByPlayerModal";
import ShortPassesModal from "../modals/ShortPassesModal";
import ShotsOnTargetModal from "../modals/ShotsOnTargetModal";
import DuelsModal from "../modals/DuelsModal";
import matchVideoThumbnail from "../../../../../assets/img/demo/matchVideoThumbnail.png";
import {gql, useQuery} from "@apollo/client";
import dustinWilliamsonAvatar from "../../../../../assets/img/demo/dustin-williamson-avatar.png";
import eduardoMilesAvatar from "../../../../../assets/img/demo/eduardo-miles-avatar.png";
import Tools from "../../../../../Tools";


class StatsAndVideosPerMatchDataTable extends DataTableBase {
    constructor(props) {
        super(props);

        this.state = this.getInitState();
    }

    getInitState = () => {
        return {
            videoModal: {
                show: false,
                selectedVideo: null,
                selectedMatch: null,
            },
            performanceInMinutesPlayedModal: {
                show: false,
            },
            assistsByPlayerModal: {
                show: false,
            },
            shortPassesModal: {
                show: false,
            },
            shotsOnTargetModal: {
                show: false,
            },
            duelsModal: {
                show: false,
            },

        };
    };

    /**
     * Render StatsAndVideosPerMatchDataTable component.
     * @returns {React.ReactNode} The StatsAndVideosPerMatchDataTable component.
     */
    render = () => {
        return (
            <Fragment>
                {this.renderTable()}
                {this.renderPagination()}
                {this.renderModals()}
            </Fragment>
        );
    };

    renderModals = () => {
        const {videoModal, performanceInMinutesPlayedModal, assistsByPlayerModal, shortPassesModal, shotsOnTargetModal, duelsModal} = this.state;
        const {selectedVideo, show: videoModalShow} = videoModal;
        const {show: performanceInMinutesPlayedModalShow} = performanceInMinutesPlayedModal;
        const {show: assistsByPlayerModalShow} = assistsByPlayerModal;
        const {show: shortPassesModalShow} = shortPassesModal;
        const {show: shotsOnTargetModalShow} = shotsOnTargetModal;
        const {show: duelsModalShow} = duelsModal;

        const videos = this.getSelectedMatchVideos();

        return (
            <Fragment>
                <VideosPerMatchModal videos={videos} selected={selectedVideo} show={videoModalShow} onHide={() => this.setVideoModalShow(false)}/>
                <PerformanceInMinutesPlayedModal show={performanceInMinutesPlayedModalShow} onHide={() => this.setPerformanceInMinutesPlayedModalShow(false)}/>
                <AssistsByPlayerModal show={assistsByPlayerModalShow} onHide={() => this.setAssistsByPlayerModalShow(false)}/>
                <ShortPassesModal show={shortPassesModalShow} onHide={() => this.setShortPassesModalShow(false)}/>
                <ShotsOnTargetModal show={shotsOnTargetModalShow} onHide={() => this.setShotsOnTargetModalShow(false)}/>
                <DuelsModal show={duelsModalShow} onHide={() => this.setDuelsModalShow(false)}/>
            </Fragment>
        );
    };

    renderMatchDetails = (matchData) => {
        const {team1, team2, division, datetime} = matchData;
        const {name: team1Name, shortName: team1ShortName, goals: team1Goals} = team1;
        const {name: team2Name, shortName: team2ShortName, goals: team2Goals} = team2;

        return (
            <div className="match-details">
                <div className="teams"> {team1Name} VS {team2Name} </div>
                <div className="goals"> Goals {team1ShortName} {team1Goals} - {team2ShortName} {team2Goals}</div>
                <div className="division"> {division} </div>
                <div className="datetime"> {datetime} </div>
            </div>
        );
    };

    renderPercentageCell = (cellData, showModal) => {
        const {value, total} = cellData;
        let percentage;
        if (total !== 0)
            percentage = Math.round(100 * value / total) + '%';
        else
            percentage = '-';

        return (
            <div className="percentage-cell">
                <div className="value"> {value} </div>
                <div className="total"> of {total} </div>
                <div className="percentage"> {percentage}</div>
                <FontAwesomeIcon icon={faChartLine} className="chart" onClick={() => typeof showModal === 'function' && showModal(true)}/>
            </div>
        );
    };

    renderVideoCell = (cellData, columnName, matchId) => {
        const {link, thumbnail, duration} = cellData;
        const durationValue = duration + " Min";
        const scored = thumbnail !== null;

        const params = {
            matchId: matchId,
            columnName: columnName,
            link: link,
        };

        if (scored)
            return (
                <StatsAndVideosPerMatchDataTable.ScoredVideoItem
                    link={link}
                    thumbnail={thumbnail}
                    duration={durationValue}
                    onClick={(event) => this.handleVideoItemClick(event, params)}/>
            );
        else {
            return (
                <StatsAndVideosPerMatchDataTable.NotScoredVideoItem/>
            );
        }
    };

    renderCard = (cardData) => {
        const {yellow, red} = cardData;
        return (
            <div className="d-flex flex-row">
                <div className="yellow-card-container">
                    <div className="yellow-card"/>
                    <div className="value"> {yellow} </div>
                </div>
                <div className="red-card-container">
                    <div className="red-card"/>
                    <div className="value"> {red} </div>
                </div>
            </div>
        );
    };

    renderRow = (rowData, rowIndex) => {
        const {type} = this.props;
        if (type === 'stats')
            return this.renderStatsRow(rowData, rowIndex);
        else if (type === 'videos')
            return this.renderVideosRow(rowData, rowIndex);
    };

    renderStatsRow = (rowData, rowIndex) => {
        const {match, stats} = rowData;
        const {position, minutes, goals, assists, shotsOnTarget, penalties, shortPasses, longPasses, crosses, dribbles, duels, arielDuel, losses, recoveries, card} = stats;

        return {
            match: this.renderMatchDetails(match),
            minutes: this.renderPercentageCell(minutes, this.setPerformanceInMinutesPlayedModalShow),
            goals: this.renderPercentageCell(goals),
            assists: this.renderPercentageCell(assists, this.setAssistsByPlayerModalShow),
            shotsOnTarget: this.renderPercentageCell(shotsOnTarget, this.setShotsOnTargetModalShow),
            penalties: this.renderPercentageCell(penalties),
            shortPasses: this.renderPercentageCell(shortPasses, this.setShortPassesModalShow),
            longPasses: this.renderPercentageCell(longPasses),
            crosses: this.renderPercentageCell(crosses),
            dribbles: this.renderPercentageCell(dribbles),
            duels: this.renderPercentageCell(duels, this.setDuelsModalShow),
            arielDuel: this.renderPercentageCell(arielDuel),
            losses: this.renderPercentageCell(losses),
            recoveries: this.renderPercentageCell(recoveries),
            card: this.renderCard(card),
            position: position,
        };
    };

    renderVideosRow = (rowData, rowIndex) => {
        const {id, match, videos} = rowData;
        const videosCells = Object.keys(videos).reduce((result, columnName) => {
            result[columnName] = this.renderVideoCell(videos[columnName], columnName, id);
            return result;
        }, {});

        return {
            match: this.renderMatchDetails(match),
            ...videosCells,
        };
    };

    statsColumnsConfig = () => {
        return [
            {
                dataField: 'match',
                text: 'Match',
            }, {
                dataField: 'position',
                text: 'Position',
            }, {
                dataField: 'minutes',
                text: 'Minutes',
            }, {
                dataField: 'goals',
                text: 'Goals',
            }, {
                dataField: 'assists',
                text: 'Assists',
            }, {
                dataField: 'shotsOnTarget',
                text: 'Shots on target',
            }, {
                dataField: 'penalties',
                text: 'Penalties',
            }, {
                dataField: 'shortPasses',
                text: 'Short Passes',
            }, {
                dataField: 'longPasses',
                text: 'Long Passes',
            }, {
                dataField: 'crosses',
                text: 'Crosses',
            }, {
                dataField: 'dribbles',
                text: 'Dribbles',
            }, {
                dataField: 'duels',
                text: 'Duels',
            }, {
                dataField: 'arielDuel',
                text: 'Ariel Duel',
            }, {
                dataField: 'losses',
                text: 'Losses',
            }, {
                dataField: 'recoveries',
                text: 'Recoveries',
            }, {
                dataField: 'card',
                text: 'Card',
            },
        ];
    };

    videosColumnsConfig = () => {
        return [
            {
                dataField: 'match',
                text: 'Match',
            },
            {
                dataField: 'fullMatch',
                text: 'Full Match',
                type: 'video',
            }, {
                dataField: 'bestAction',
                text: 'Best Action',
                type: 'video',
            }, {
                dataField: 'teamGoals',
                text: 'Team Goals',
                type: 'video',
            }, {
                dataField: 'individualGoals',
                text: 'Individual Goals',
                type: 'video',
            }, {
                dataField: 'assists',
                text: 'Assists',
                type: 'video',
            }, {
                dataField: 'shortPasses',
                text: 'Short Passes',
                type: 'video',
            }, {
                dataField: 'longPasses',
                text: 'Long Passes',
                type: 'video',
            }, {
                dataField: 'shots',
                text: 'Shots',
                type: 'video',
            }, {
                dataField: 'penalties',
                text: 'Penalties',
                type: 'video',
            }, {
                dataField: 'fouls',
                text: 'Fouls',
                type: 'video',
            }, {
                dataField: 'paddingRight',
                text: '',
            }
        ];
    };

    /**
     * Returns the table columns configurations.
     * @returns {{dataField: string, text: string, headerTitle: string, sort :boolean}[]} .
     * dataField: the dataField.
     * text: The column display name.
     */
    columnsConfig = () => {
        const {type} = this.props;

        if (type === 'stats')
            return this.statsColumnsConfig();
        else if (type === 'videos')
            return this.videosColumnsConfig();
    };

    expandRowConfig = () => {
        return {
            enable: false,
        };
    };

    selectRowConfig = () => {
        return {
            enable: false,
        };
    };


    /**
     * Setters
     */

    setModalShow(modal, active) {
        const newState = this.state;
        newState[modal].show = active;
        this.setState(newState);
    };

    setVideoModalShow = (active) => {
        this.setModalShow('videoModal', active);
    };
    setPerformanceInMinutesPlayedModalShow = (active) => {
        this.setModalShow('performanceInMinutesPlayedModal', active);
    };
    setAssistsByPlayerModalShow = (active) => {
        this.setModalShow('assistsByPlayerModal', active);
    };
    setShortPassesModalShow = (active) => {
        this.setModalShow('shortPassesModal', active);
    };
    setShotsOnTargetModalShow = (active) => {
        this.setModalShow('shotsOnTargetModal', active);
    };
    setDuelsModalShow = (active) => {
        this.setModalShow('duelsModal', active);
    };


    /**
     * Getters
     */

    getSelectedMatchVideos = () => {
        const {videoModal} = this.state;
        const {selectedMatch, selectedVideo} = videoModal;

        if (!selectedMatch)
            return [];

        return this.columnsConfig().filter((column) => column.type === 'video').map((column) => {
            return {
                ...selectedMatch.videos[column.dataField],
                dataField: column.dataField,
                title: column.text,
            };
        }).filter((video) => video.thumbnail !== null);
    };

    /**
     * Handlers
     */

    handleVideoItemClick = (event, params) => {
        const {matchId, columnName, link} = params;
        const {rows} = this.props;

        const result = rows.filter((match) => match.id === matchId);
        const match = result.length !== 0 ? result[0] : null;


        this.setState({
            ...this.state,
            videoModal: {
                show: true,
                selectedVideo: columnName,
                selectedMatch: match,
            }
        });
    };


    extraClasses = {
        table: 'stats-and-videos-per-match-datatable'
    };

    static propTypes = {
        // Callback fire when click video item.
        onVideoClick: PropTypes.func.isRequired,
    };
}

StatsAndVideosPerMatchDataTable.ScoredVideoItem = ScoredVideoItem;
StatsAndVideosPerMatchDataTable.NotScoredVideoItem = NotScoredVideoItem;

const StatsAndVideosPerMatchDataTableDataWrapper = props => {
    const query = gql`
        query getPlayerMatches(
            $player: String!
            $take: Int
            $skip: Int
        ){
            matches: getPlayerMatchStats(
                player: $player
                take: $take
                skip: $skip
            ){
                total
                filteredFrom
                results{
                    ...PlayerMatchStatsFields
                }
            }
        }

        fragment PlayerMatchStatsFields on MatchPlayerStatsModel {
            homeTeam{
                ...teamField
            }
            awayTeam{
                ...teamField
            }

            competition{
                name
            }

            eventDate

            position
            minutes
            minutesOf
            goals
            goalsOf
            assists
            shotsOnGoal
            shotsOnGoalOf
            penalties

            shortPasses
            shortPassesOf
            longPasses
            longPassesOf

            crossess
            crossessOf

            dripples
            dripplesOf

            dules
            dulesOf

            arielDules
            arielDulesOf

            losses
            lossesOf

            recoveries
            recoveriesOf

            yellowCard
            redCard
        }

        fragment teamField on MatchTeamModel {
            team{
                name
                code
            }
        }
    `;

    const formatMatch = (match) => ({
        team1: {
            name: match.homeTeam.team.name,
            shortName: match.homeTeam.team.code,
            goals: 2,
        },
        team2: {
            name: match.awayTeam.team.name,
            shortName: match.awayTeam.team.code,
            goals: 0,
        },
        division: match.competition.name,
        datetime: Tools.formatDate(match.eventDate, {
            sameDay: '[Today] HH:mm',
            nextDay: '[Tomorrow] HH:mm',
            nextWeek: 'dddd HH:mm',
            sameElse: 'DD/MM/YYYY HH:mm'
        })
    });

    const formatStats = (match) => ({
        position: match.position,
        minutes: {
            value: match.minutes,
            total: match.minutesOf,
        },
        goals: {
            value: match.goals,
            total: match.goalsOf,
        },
        assists: {
            value: match.assists,
            total: match.shotsOnGoalOf,
        },
        shotsOnTarget: {
            value: match.shotsOnGoal,
            total: match.shotsOnGoalOf,
        },
        penalties: {
            value: match.penalties,
            total: match.shotsOnGoalOf,
        },
        shortPasses: {
            value: match.shortPasses,
            total: match.shortPassesOf,
        },
        longPasses: {
            value: match.longPasses,
            total: match.longPassesOf,
        },
        crosses: {
            value: match.crossess,
            total: match.crossessOf,
        },
        dribbles: {
            value: match.dripples,
            total: match.dripplesOf,
        },
        duels: {
            value: match.dules,
            total: match.dulesOf,
        },
        arielDuel: {
            value: match.arielDules,
            total: match.arielDulesOf,
        },
        losses: {
            value: match.losses,
            total: match.lossesOf,
        },
        recoveries: {
            value: match.recoveries,
            total: match.recoveriesOf,
        },
        card: {
            yellow: match.yellowCard,
            red: match.redCard,
        },
    });

    const formatVideos = (match) => ({
        fullMatch: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        bestAction: {
            link: 'https://static.videezy.com/system/protected/files/000/000/360/MAH00003.MP4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        teamGoals: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        individualGoals: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        assists: {
            link: '',
            duration: 91,
            thumbnail: null,
        },
        shortPasses: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        longPasses: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        shots: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: null,
        },
        penalties: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        fouls: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
    });

    const formatter = (matches) => {
        if (!matches)
            return [];

        return matches.map((match) => ({
            match: formatMatch(match),
            stats: formatStats(match),
            videos: formatVideos(match),
        }));
    };


    // Get filters values from props.
    const {regions, countries, competitions, teams, venues, search: _q} = props;
    const [q, setQ] = useState(_q);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        pageSize: 10,
    });

    // Set request parameters.
    const variables = {
        player: "5e9ed264a957481f94a88f60",
        q: Tools.convertEmptyToNull(q),
        regions: Tools.convertEmptyToNull(regions),
        countries: Tools.convertEmptyToNull(countries),
        competitions: Tools.convertEmptyToNull(competitions),
        teams: Tools.convertEmptyToNull(teams),
        stadiums: Tools.convertEmptyToNull(venues),
        skip: (pagination.currentPage - 1) * pagination.pageSize,
        take: pagination.pageSize,
    };

    const {loading, error, data} = useQuery(query, {
        variables: variables,
        notifyOnNetworkStatusChange: true
    });

    // Format data.
    const matches = formatter(data?.matches?.results);
    const filteredFrom = data?.matches?.filteredFrom;
    const total = data?.matches?.total;

    // Pass props.
    const feedbackProps = {
        loading: loading,
        error: error,
    };

    const paginationProps = {
        currentPage: pagination.currentPage,
        pageSize: pagination.pageSize,
        total: total,
        filteredFrom: filteredFrom,
    };

    const dataProps = {
        rows: matches,
    };

    const handlersProp = {
        onPageChange: (_pagination) => setPagination({...pagination, ..._pagination}),
    };

    return (
        <StatsAndVideosPerMatchDataTable
            {...feedbackProps}
            {...paginationProps}
            {...dataProps}
            {...handlersProp}

            {...props}
        />
    );
};

export default StatsAndVideosPerMatchDataTableDataWrapper;
